/* @ngInject */
export default function ($scope, LayoutService, StaffReportsAdverseEventsService, toastr, $state, AdverseEvents, PreferencesService, PermissionsUsers, PermissionsServiceUsers, $q) {
	LayoutService.setTitle('New Adverse Event');
	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Save</button>');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       null,
			             displayName: 'Reports',
		             },
		             {
			             route:       'staff.reports.adverseEvents.root',
			             displayName: 'Adverse Events Report',
		             },
		             {
			             route:       'staff.reports.adverseEvents.new',
			             displayName: 'New Adverse Event',
		             },
	             ]);

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.loading = true;

	$scope.relatesToOptions = [
		'Admin/Rostering Error',
		'Financial Error',
		'WHS Risk',
		'Clinical Adverse Event',
		'Serious Adverse Event',
		'Capacity Issues',
		'Authorized RRP',
		'Unauthorized RRP',
		'SU COVID',
		'SW COVID',
		'Other (must only be used when the issue cannot be covered in the above categories)',
	];

	$scope.adverseEvent = {
		'relatesTo':       [],
		'serviceUserId':   null,
		'supportWorkerId': null,
		'occurredAt':      null,
		'description':     null,
		'whereOccurred':   null,
		'whatOccurred':    null,
		'howOccurred':     null,
		'whyOccurred':     null,
		'howAddressed':    null,
		'howPrevent':      null,
		'correspondence':  null,
		'resolvedAt':      null,
	};

	$scope.toggleRelatesTo = function (value) {
		if ($scope.adverseEvent.relatesTo.indexOf(value) === -1) {
			$scope.adverseEvent.relatesTo.push(value);
		} else {
			$scope.adverseEvent.relatesTo.splice($scope.adverseEvent.relatesTo.indexOf(value), 1);
		}
	};

	$scope.refresh = () => {
		$scope.loading = true;

		$q.all([
			PermissionsUsers.getList({
				include: 'workable',
			}),
			PermissionsServiceUsers.getList(),
		])
		  .then((results) => {
			  $scope.supportWorkers = results[0];

			  $scope.serviceUsers = results[1].filter((serviceUser) => {
				  return serviceUser.status === 1; // Active
			  })
			                                  .map((serviceUser) => {
				                                  return {
					                                  ...serviceUser,
					                                  shortCode: (serviceUser.shortCode) ? ('SU#' + serviceUser.shortCode) : ('N/A'),
				                                  };
			                                  });

			  $scope.loading = false;
		  });
	};

	$scope.save = () => {
		if ($scope.loading === false) {
			const adverseEvent = $scope.adverseEvent;

			AdverseEvents
				.post(adverseEvent)
				.then((data) => {
					toastr.clear();
					toastr.success('The adverse event was saved successfully.', 'Success');

					$state.go('staff.reports.adverseEvents.root');
				})
				.catch((data) => {
					toastr.clear();
					toastr.error('There was an error while saving the adverse event, please try again.', 'Error');
				});
		} else {
			toastr.clear();
			toastr.warning('You must wait for the page to load before saving your adverse event.');
		}
	};

	LayoutService.getPageHeader()
	             .onClicked($scope.save);

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/adverseEvents/new/controller.js